module.exports = __webpack_public_path__ + "eb577aa34a54a61328fc52cb5e08640c.svg";